import dayjs from "dayjs";

const rtf = new Intl.RelativeTimeFormat("es-MX", { numeric: "auto" });
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

// Solo día/hora/minuto: para diferencias >= 1 semana se usa la fecha
// absoluta (ver WEEK_MS más abajo), así que semana/mes/año nunca aplican aquí.
const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ["day", 1000 * 60 * 60 * 24],
    ["hour", 1000 * 60 * 60],
    ["minute", 1000 * 60],
];

/**
 * "Hace 5 minutos", "ayer". Para fechas de más de una semana muestra la
 * fecha absoluta corta (p.ej. "10 sep 2026"): a esa distancia el relativo
 * deja de ser informativo.
 */
export function formatRelative(dateIso: string): string {
    const date = new Date(dateIso);
    const diffMs = date.getTime() - Date.now();

    if (Math.abs(diffMs) >= WEEK_MS) {
        return dayjs(date).format("D MMM YYYY");
    }

    for (const [unit, unitMs] of UNITS) {
        if (Math.abs(diffMs) >= unitMs || unit === "minute") {
            return rtf.format(Math.round(diffMs / unitMs), unit);
        }
    }

    return rtf.format(0, "minute");
}
